
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-9e55d97e&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BlockGraph.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BlockGraph.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-9e55d97e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BlockGraph.vue"),
  /* scopeId */
  "data-v-9e55d97e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/BlockGraph.vue
// module id = ./dev/src/components/BlockGraph.vue
// module chunks = 0